const REACT_APP_API_URL = 'https://adminsukien.myu.vn/api';
// const REACT_APP_API_URL = 'http://localhost:5005/api';

export { REACT_APP_API_URL };